export default __webpack_public_path__ + "static/media/aboutme.ed308e58.png";